module.exports = __webpack_public_path__ + "img/web-shop.b5726f20.svg";